import { Heading, Panel, Text } from '@afterpaytouch/core'
import React, { FunctionComponent, ReactElement } from 'react'
import { useConsumerSizes } from '../../utils/responsive'
import { useTranslation } from 'next-i18next'

const I18N_NAMESPACE = ['common', 'payMonthly']

export const PayMonthlyPanel: FunctionComponent<{ children: ReactElement }> = ({ children }) => {
  const { headingSize } = useConsumerSizes()
  const { t } = useTranslation(I18N_NAMESPACE)
  const description = t('payMonthly:panel:head:description')

  return (
    <Panel testNameSpace='pay-monthly'>
      <Panel.Head>
        <div className='mb-2'>
          <Heading size={headingSize}>{t('payMonthly:panel:head:heading')}</Heading>
        </div>
        {description ? <Text>{description}</Text> : null}
      </Panel.Head>
      <Panel.Content>{children}</Panel.Content>
    </Panel>
  )
}
